<a [routerLink]="UrlConstants.buildUrl(UrlConstants.CONTACT)" class="text-link">{{'footer.faq' | translate}}</a>
<a [routerLink]="UrlConstants.buildUrl(UrlConstants.CONTACT)" class="text-link">{{'footer.contact' | translate}}</a>
<a [routerLink]="UrlConstants.buildUrl(UrlConstants.TERMS_AND_CONDITIONS)" class="text-link">{{'footer.termsAndConditions' | translate}}</a>
<a [routerLink]="UrlConstants.buildUrl(UrlConstants.TERMS_OF_USE)" class="text-link">{{'footer.termsofUse' | translate}}</a>
<a [routerLink]="UrlConstants.buildUrl(UrlConstants.PRIVACY_POLICY)" class="text-link">{{'footer.dataProtectionPolicy' | translate}}</a>
<a *ngIf="authService.isLoggedIn()" [routerLink]="" (click)="onNavigateToUserGuide()"  class="text-link user-guide-link">{{'footer.userGuide' | translate}}</a>
<a routerLink="/documentation" target="_blank" class="text-link">{{'footer.swagger' | translate}}</a>
<span class="version-text">v{{appVersion}}</span>

<div *ngIf="authService.isLoggedIn()" class="footer-chatbox-container" lang="en" data-language="en">
    <wlcp-chatbox></wlcp-chatbox>
</div>
